import React from 'react'

import { Icon, Tooltip } from 'src/govwell-ui'
import type { IconKey } from 'src/govwell-ui/components/Icon/util'

type Props = {
  ariaLabel: string
  icon: IconKey
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void
  tooltip: string
}

const PillChromeIconAction = ({ ariaLabel, icon, onClick, tooltip }: Props) => (
  <Tooltip asChild content={tooltip}>
    <button
      type="button"
      aria-label={ariaLabel}
      className="ml-auto inline-flex size-3.5 shrink-0 items-center justify-center rounded-full text-inherit hover:bg-black/5"
      onClick={onClick}
    >
      <Icon icon={icon} className="size-2.5" />
    </button>
  </Tooltip>
)

export default React.memo(PillChromeIconAction)
